import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <Seo title="Page not found — Fast Estimate" path="/404" noindex />
      <SiteNav />
      <main className="mx-auto max-w-2xl px-4 py-24 text-center">
        <h1 className="font-heading text-4xl font-black text-slate-900">Page not found</h1>
        <p className="mt-4 text-slate-600">That page doesn't exist. Try one of these instead:</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/"><Button data-testid="notfound-home" variant="outline" className="h-12 rounded-xl border-2 font-bold">Home</Button></Link>
          <Link to="/pricing"><Button variant="outline" className="h-12 rounded-xl border-2 font-bold">Pricing</Button></Link>
          <Link to="/signup"><Button className="h-12 rounded-xl bg-indigo-500 font-bold hover:bg-indigo-600">Start free trial</Button></Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
